<template>
    <div v-if="!isHidden" class="b_articles section">
        <div class="container">
            <div class="section_title">
                <h3>
                    {{ content.title || content.moreInformation?.title }}
                </h3>
            </div>
            <div class="article_wrapper">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="article_card"
                >
                    <div class="article_row">
                        <article class="card_block">
                            <component
                                :is="isExternalLink(item) ? 'a' : 'nuxt-link'"
                                v-bind="getLinkAttributes(item)"
                                class="card_head"
                            >
                                <div class="article_image">
                                    <picture
                                        v-if="
                                            checkIfProperPictureAttached(
                                                item.information?.featuredImage
                                            )
                                        "
                                        v-full-image-path.original.decorative="
                                            item.information.featuredImage
                                        "
                                    />
                                    <div v-else class="no_image">
                                        <picture
                                            v-full-image-path:assets.decorative="
                                                'article_image_no_image.svg'
                                            "
                                        />
                                    </div>
                                </div>

                                <div
                                    v-if="item.information"
                                    class="article_description"
                                >
                                    <h3>{{ item.information.text }}</h3>
                                    <p v-if="item.information.description">
                                        {{ item.information.description }}
                                    </p>
                                </div>
                                <div
                                    v-else-if="item.text"
                                    class="article_description"
                                >
                                    <h3>{{ item.text }}</h3>
                                    <p v-if="item.description">
                                        {{ item.description }}
                                    </p>
                                </div>
                            </component>

                            <div class="more_wrap self_end">
                                <component
                                    :is="
                                        isExternalLink(item) ? 'a' : 'nuxt-link'
                                    "
                                    v-bind="getLinkAttributes(item)"
                                    class="link_arrow"
                                >
                                    {{
                                        $t('homepage.buttonsSection.learnMore')
                                    }}
                                </component>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import isExternalLink from '@/helpers/isExternalLink';
import checkIfProperPictureAttached from '@/helpers/checkIfProperPictureAttached';

export default {
    props: {
        content: {
            type: Object,
            required: true
        },

        count: {
            type: Number,
            default: 4
        },

        hideAllowed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            items: []
        };
    },

    async fetch() {
        const itemsRef =
            this.content.items || this.content.moreInformation.items;
        let items = [...itemsRef];

        const contentItems = await this.getInformationByContentId(
            this.content.id
        );

        if (contentItems.length) {
            items = [...contentItems];
        }

        const missingArticlesCount = this.count - items.length;
        const existingArticlesIds = items.map(item => item.id);

        if (missingArticlesCount) {
            const missingArticles = await this.getRandomArticles({
                count: missingArticlesCount,
                excludedIds: existingArticlesIds
            });

            const mappedMissingArticles = missingArticles.map(article => {
                return {
                    id: article.id,
                    text: article.name,
                    description: article.description,
                    featuredImage: article.featuredImage,
                    link: `/articles/${
                        article.slug || article.numericId || article.id
                    }`
                };
            });

            items.push(...mappedMissingArticles);
        }

        this.items = items;
    },

    computed: {
        isHiddenFlag() {
            return (
                this.content.isHidden || this.content.moreInformation?.isHidden
            );
        },

        isHidden() {
            return this.hideAllowed && this.isHiddenFlag;
        }
    },

    methods: {
        ...mapActions({
            getRandomArticles: 'articles/random',
            getInformationByContentId: 'contents/getInformationByContentId'
        }),

        isExternalLink(item) {
            const link = item.information?.link || item.link;

            return isExternalLink(link);
        },

        getLinkAttributes(item) {
            const info = item.information || item;
            const { link, blank } = info;

            if (isExternalLink(link)) {
                return {
                    href: link,
                    ...(blank && {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    })
                };
            }

            return {
                to: link
            };
        },

        checkIfProperPictureAttached(image) {
            return checkIfProperPictureAttached(image);
        }
    }
};
</script>
